<template>
  <div id="app">
    <commonArticle :data="data"></commonArticle>
  </div>
</template>

<script>
import commonArticle from '../../../components/commonArticle.vue'
export default {
  data() {
    return {
      data: {
        title: '経営理念',
        english: 'Management Philosophy',
        content:
          '<p class="the_blue_color">１．人材こそが最大の財産</p><p>徹底した教育により、お客様へのサービス精神を持ち、日本のビジネス習慣を身に付け、豊富な技術ノウハウ・業務ノウハウを有した、真のSE人材を育成して参ります。</p><p><br></p><p class="the_blue_color">２．信用・信頼はビジネス成り立ちの基礎</p><p>“有言実行”、お客様からのご満足とご信頼を得る事を最も重視し、頂いた仕事は必ずやり遂げ、常に高品質で低コストのサービスを提供する事により、お客様との厚い信頼関係を構築して参ります。</p><p><br></p><p class="the_blue_color">３．お客様と社員が共に発展する会社を目指します</p><p>常にお客様のニーズに答えられるように努力し、信頼されるビジネスパートナを目指して、Win-Win関係を構築し「お客様と共に発展・発達する会社」を目指して参ります。社員に対しても、充実した教育と活躍の場を提供し、より高いステージを目指して参ります。</p><p><br></p><p class="the_blue_color">４．常に改善を怠らず、高効率な実行体制を構築して参ります</p><p>厳しい競争環境において、目標管理を徹底し、常にマネジメントの仕組みの改善を行い、標準化管理により高効率な実行体制を構築し、お客様に競争力があるサービスを提供して参ります。</p><p><br></p><p class="the_blue_color">５．お客様の価値創造に貢献して参ります</p><p>常に新しい技術に挑戦しマスターする事で、新規事業を開拓しお客様の期待に応えられる様な課題解決能力を身につけ、新たな価値を創造してお客様に提供して参ります。</p>'
      }
    }
  },
  components: {
    commonArticle
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped>
</style>
<style>
</style>
